<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Conversion</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="table-responsive">
    <table class="table table-hover table-striped align-middle">
      <thead class="thead-light">
        <tr [tableFilter]="tableFilter" [realtime]="true">
          <th></th>
          <th>
            <app-table-filter-header tableFilterName="partner"></app-table-filter-header>
          </th>
          <th>
            <app-table-filter-header tableFilterName="advertisingPlatform"></app-table-filter-header>
          </th>
          <th>
            <app-table-filter-header tableFilterName="subid"></app-table-filter-header>
          </th>
          <th>
            <app-table-filter-header tableFilterName="tc1"></app-table-filter-header>
          </th>
          <th>
            <app-table-filter-header tableFilterName="tc2"></app-table-filter-header>
          </th>
          <th>
            <app-table-filter-header tableFilterName="tc3"></app-table-filter-header>
          </th>
          <th>
            <app-table-filter-header tableFilterName="type"></app-table-filter-header>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <app-table-filter-header tableFilterName="allocated" [choices]="filterAllocatedChoices"
            class="allocatedFilter"></app-table-filter-header>
          </th>
        </tr>
        <tr [tableSorter]="tableSorter">
          <th>Date</th>
          <th tableSorterHeader="partner">Partner</th>
          <th tableSorterHeader="advertisingPlatform">Platform</th>
          <th tableSorterHeader="subid">Ads account</th>
          <th tableSorterHeader="tc1">Campaign</th>
          <th tableSorterHeader="tc2">Ad Group</th>
          <th tableSorterHeader="tc3">Creative</th>
          <th tableSorterHeader="type">Type</th>
          <th tableSorterHeader="impressions">Impressions</th>
          <th tableSorterHeader="clicks">Clicks</th>
          <th tableSorterHeader="cost">Cost</th>
          <th tableSorterHeader="costUsd">Cost USD</th>
          <th tableSorterHeader="allocated">Allocated</th>
        </tr>
      </thead>
      <tbody>
        @for (cost of costs | tableFilter: tableFilter | tableSort: tableSorter; track cost) {
          <tr>
            <td>{{ cost.date | date:'dd/MM/yyyy' }}</td>
            <td>{{ cost.partner }}</td>
            <td>{{ cost.advertisingPlatform }}</td>
            <td>{{ cost.subid }}</td>
            <td>{{ cost.tc1 }}</td>
            <td>{{ cost.tc2 }}</td>
            <td>{{ cost.tc3 }}</td>
            <td>{{ cost.type }}</td>
            <td>{{ cost.impressions }}</td>
            <td>{{ cost.clicks }}</td>
            <td>{{ cost.cost | money }}</td>
            <td>{{ cost.costUsd | money:2:'USD' }}</td>
            <td>
              @if (cost.allocated) {
                <span class="badge text-bg-success rounded-pill">Yes</span>
              }
              @if (!cost.allocated) {
                <span class="badge text-bg-danger rounded-pill">No</span>
              }
            </td>
          </tr>
        }
        <tr>
          <td class="fw-bold">Total</td>
          <td colspan="7"></td>
          <td class="fw-bold">{{ getTotal('impressions') }}</td>
          <td class="fw-bold">{{ getTotal('clicks') }}</td>
          <td class="fw-bold">{{ getTotal('cost') | money }}</td>
          <td class="fw-bold">{{ getTotal('costUsd') | money:2:'USD' }}</td>
          <td class="fw-bold"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
